import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import ChangePasswordForm from './ChangePasswordForm';
import axios from '../../lib/axiosInstance';
import 'react-toastify/dist/ReactToastify.css';
class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      success_message: '',
      is_passwordchanged: false,
      verifyDevice: false,
      remember_me: false,
    };
  }
  renderNotification() {
    return (
      <>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }
  async changeUserPassword() {
    this.setState({ is_passwordchanged: true });
    console.log(
      this.props,
      this.props.match.params,
      this.props.match.params.resetToken,
    );
    if (this.state.password) {
      let data = {
          password: this.state.password,
          confirm_password: this.state.confirm_password,
        },
        url = '/profiles/change-password/' + this.props.match.params.resetToken;
      await axios
        .put(url, data)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            this.setState({ success_message: res.data.success });
            toast('Success! ' + res.data.success, {
              position: 'bottom-right',
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error('Authentication Failed! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => {
              this.setState({ is_passwordchanged: false });
            }, 1000);
          }
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 422) {
            localStorage.removeItem('refresh');
            localStorage.removeItem('access');
            localStorage.removeItem('refreshTokenSetAt');
            localStorage.removeItem('accessTokenSetAt');
            toast.error('Authentication Failed! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (res.status === 200) {
            toast.error('Authentication Failed! ' + res.data, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          setTimeout(() => {
            this.setState({ is_passwordchanged: false });
          }, 1000);
        });
      let self = this;
      setTimeout(function () {
        self.setState({ verifyDevice: true });
      }, 60);
    }
  }
  setValue(key, value) {
    if (key) {
      if (key === 'remember_me') {
        let remember_me = this.state.remember_me;
        this.setState({ remember_me: !remember_me });
      } else {
        this.setState({ [key]: value });
      }
    }
  }
  componentDidMount() {
    let device_uid = localStorage.getItem('device_uid');
    if (device_uid === undefined || device_uid === '' || device_uid === null) {
      var dateObject = new Date();
      device_uid =
        dateObject.getFullYear() +
        '' +
        dateObject.getMonth() +
        '' +
        dateObject.getDate() +
        '' +
        dateObject.getTime();
      localStorage.setItem('device_uid', device_uid);
    }
  }
  render() {
    return (
      <>
        <div className="loginscreen">
          <ChangePasswordForm
            parentContext={this}
            changeUserPassword={this.changeUserPassword.bind(this)}
            setValue={this.setValue.bind(this)}
            appContext={this.props.parentContext}
          />
        </div>
        {this.renderNotification()}
      </>
    );
  }
}
export default ChangePassword;
